module.exports = __webpack_public_path__ + "static/media/NUS_Industrial&Systems_Engineering.cef2e9ac.png";